import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import '../css/HomeMini.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'


class HeadingBox extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {


    return (

        <Row>
            <Card className="mb-2 p-2" style={{ width: '100%', marginRight: '30px', marginLeft: '30px'}}>
                <Card.Body className="p-0">
                  <p className="mb-0 header" >{this.props.title}</p>
                </Card.Body>
            </Card>
        </Row>

    );
  }
}

export default HeadingBox;
